const QUERY_STRING_PREFIX = '?';

function extractQueryParamPairStrings(urlString) {
  let queryParamsString;
  const urlStringPartials = urlString.split(QUERY_STRING_PREFIX);

  if (urlStringPartials.length === 1) {
    queryParamsString = urlString;
  } else {
    queryParamsString = urlStringPartials[1];
  }

  return queryParamsString.split(/&&|&/gi);
}

function setGlobalUtagDataIfOnClient(utagData) {
  if (process.env.BROWSER) {
    window.utagData = utagData;
    window.utagData.page_url = window.location.href;
    window.utagData.page_referring_url = '';
    window.utagData.page_query_string = extractQueryParamPairStrings(
      window.location.search,
    );
    window.utagData.project = 'pwa';
  }
}

function setGlobalDataLayerIfOnClient(utagData) {
  if (process.env.BROWSER && window.dataLayer) {
    Object.assign(window.dataLayer, utagData);

    window.dataLayer.page_url = window.location.href ? window.location.href : '';
    window.dataLayer.page_referring_url = '';
    window.dataLayer.page_query_string = extractQueryParamPairStrings(
      window.location.search
    );
  }
}

const utagBootstrapper = {
  init(seoInfo) {
    if (seoInfo?.utagData) {
      setGlobalUtagDataIfOnClient(seoInfo.utagData);
      setGlobalDataLayerIfOnClient(seoInfo.utagData);
    }
  },
};

export default utagBootstrapper;
